import { render, staticRenderFns } from "./EditBranchForm.vue?vue&type=template&id=677d2cde&scoped=true&"
import script from "./EditBranchForm.vue?vue&type=script&lang=js&"
export * from "./EditBranchForm.vue?vue&type=script&lang=js&"
import style0 from "./EditBranchForm.vue?vue&type=style&index=0&id=677d2cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d2cde",
  null
  
)

export default component.exports